import {
	IonAlert,
	IonButton,
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardTitle,
	IonGrid,
	IonHeader,
	IonIcon,
	IonImg,
	IonLoading,
	IonPage,
	IonSelect,
	IonSelectOption,
	IonToast,
	isPlatform,
} from "@ionic/react";
import {
	AuthError,
	GoogleAuthProvider,
	OAuthCredential,
	OAuthProvider,
	fetchSignInMethodsForEmail,
	getAuth,
	getIdTokenResult,
	getRedirectResult,
	linkWithCredential,
	linkWithPopup,
	linkWithRedirect,
	signInWithCredential,
	signInWithCustomToken,
	signInWithPopup,
	signInWithRedirect,
	User,
} from "firebase/auth";
import { chevronDownOutline, globeOutline, logoApple, logoGoogle, logoMicrosoft } from "ionicons/icons";
import React from "react";
import { isAndroid, isIOS, isMobile, isTablet } from "react-device-detect";
import { Trans } from "react-i18next";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import reasyLogoBook from "../../../assets/icons/reasy_logo_book.svg";
import reasyScritta from "../../../assets/icons/reasy_scritta.svg";
import check from "../../../assets/illustrations/check.json";
import { appleAuthProvider, auth, microsoftAuthProvider } from "../../../firebaseConfig";
import i18n from "../../../i18n";
import "./AuthenticationGetStarted.css";
// import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth'
import { SignInWithApple, SignInWithAppleResponse, SignInWithAppleOptions } from "@capacitor-community/apple-sign-in";
import Cookies from "js-cookie";
import { userServices } from "../../user/store/services";
import { SocialLogin } from "@capgo/capacitor-social-login";
import { Capacitor } from "@capacitor/core";
import { ExtendedGoogleLoginResponse } from "../store/reducers";
import { createUser } from "../store/actions";
import axios from "axios";
import { backendApi } from "../../../common/apiService";
import { getAuthErrorCode, signInWithMicrosoft } from "./utils/authUtils";

type Props = {
	history: any;
	isAuthenticated: boolean;
};
declare global {
	interface Window {
		google?: {
			accounts: {
				id: {
					initialize: (config: { client_id: string; callback: (response: { credential: string }) => void }) => void;
					renderButton: (
						element: HTMLElement,
						options: {
							theme?: "outline" | "filled_blue" | "filled_black";
							size?: "large" | "medium" | "small";
							width?: string;
						}
					) => void;
					prompt: () => void;
				};
			};
		};
	}
}
type State = {
	policyChecked: boolean;
	email: string | null | undefined;
	isValidEmail: boolean;
	showConfirmationLabel: boolean;
	language: string;
	languageChanged: boolean;
	pendingCred: OAuthCredential | null;
	linkWithGoogleEmail: string | null;

	showErrorMessageToast: boolean;
	errorMessage: string | null;
	isLoading: boolean;

	fromInvitation: boolean;
	fromReferral: boolean;
	referrerName: string;
	isGoogleLoaded: boolean;
	user: {
		name: string;
		email: string;
		picture: string;
	};
	isSignedIn: boolean;
};

class AuthenticationGetStarted extends React.Component<Props, State> {
	buttonRef: React.RefObject<HTMLDivElement>;

	constructor(props: any) {
		super(props);
		this.state = {
			policyChecked: false,
			email: "",
			isValidEmail: false,
			showConfirmationLabel: false,
			language: "",
			languageChanged: false,
			pendingCred: null,
			linkWithGoogleEmail: null,

			showErrorMessageToast: false,
			errorMessage: null,
			isLoading: false,

			fromInvitation: false,
			fromReferral: false,
			referrerName: "",
			isGoogleLoaded: false,
			user: {
				name: "",
				email: "",
				picture: "",
			},
			isSignedIn: false,
		};
		this.buttonRef = React.createRef();
	}
	componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
		this.loadGoogleScript();
	}
	componentDidMount(): void {
		// console.log(i18n.language, this.state.languageChanged)
		if (!this.state.languageChanged) {
			switch (i18n.language) {
				case "en-GB":
					this.setState({ language: "en" });
					break;
				case "en-US":
					this.setState({ language: "en" });
					break;
				case "it-IT":
					this.setState({ language: "it" });
					break;
				case "es-ES":
					this.setState({ language: "es" });
					break;
				default:
					this.setState({ language: i18n.language });
			}
		}
		const urlParams = new URLSearchParams(window.location.search);
		const textValue = urlParams.get("topic");
		const referral_code = urlParams.get("referral_code");
		const invitationToken = Cookies.get("org_invitation_token");
		const invitationResponse = Cookies.get("invitation_response");

		if (invitationToken && invitationResponse) {
			/* COMING FROM /invitation PAGE -> redirect to /invitation after login */
			this.setState({ fromInvitation: true });
		}

		if (textValue) {
			// Decode the URL-encoded value
			const decodedValue = decodeURIComponent(textValue);
			console.log("TEXT VALUE:", decodedValue);

			const expirationTime = new Date(new Date().getTime() + 10 * 60 * 1000); // 10 minutes from now
			Cookies.set("topicCookie", decodedValue, { path: "/", expires: expirationTime });
		}
		if (referral_code) {
			this.setState({ fromReferral: true });
			const expirationTime = new Date(new Date().getTime() + 10 * 60 * 1000); // 10 minutes from now
			Cookies.set("referral_code", referral_code, { path: "/", expires: expirationTime });
			userServices
				.getReferrerInfo(referral_code)
				.then((info) => {
					this.setState({ referrerName: info.first_name });
				})
				.catch((err) => {});
		}
		this.loadGoogleScript(true);
	}
	loadGoogleScript = (forceReload = false) => {
		if (!forceReload && (window.google || this.state.isGoogleLoaded)) return;

		// Clean up existing script and global
		const existingScript = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
		if (existingScript) {
			existingScript.remove();
		}

		// Reset Google global if it exists
		if (window.google) {
			delete window.google;
		}

		const script = document.createElement("script");
		script.src = "https://accounts.google.com/gsi/client";
		script.async = true;
		script.onload = this.initializeGoogleSignIn;
		document.head.appendChild(script);

		this.setState({ isGoogleLoaded: true });
	};
	handleCredentialResponse = (response: any) => {
		console.log("Encoded JWT ID token: " + response.credential);
		this.setState({ isLoading: true });

		// Decode the JWT token to get user info (optional)
		try {
			const credential = GoogleAuthProvider.credential(response.credential);
			signInWithCredential(auth, credential)
				.then(async (result) => {
					this.setState({ isLoading: false });
					if (result) {
						await this.linkPendingCredential(result.user);
						const bearerToken = await result.user.getIdToken();
						const userCreated = await createUser(
							bearerToken,
							result.user.uid,
							result.user.displayName?.trim(),
							result.user.metadata.creationTime,
							result.user.email
						);
						console.log(userCreated);

						if (!userCreated) {
							console.error("Failed to create user");
							return;
						}
						if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
						else this.props.history.replace("/");
					} else {
						this.setState({ isLoading: false });
						console.error("SIGN IN - NO USER");
					}
				})
				.catch((err) => {
					console.error("SIGN IN ERROR: ", err);
				});
			// Here you would typically:
			// 1. Send the token to your backend for verification
			// 2. Store user session in this.state
			// 3. Navigate to authenticated area
			this.setState({
				isSignedIn: true,
			});
		} catch (error) {
			console.error("Error decoding token:", error);
		}
	};
	initializeGoogleSignIn = () => {
		if (window.google && window.google.accounts) {
			window.google.accounts.id.initialize({
				client_id: "888298030729-4drthn6uc61e2b7p2coqskl19j8d58r7.apps.googleusercontent.com", // Replace with your actual client ID
				callback: this.handleCredentialResponse,
			});

			// Render the button
			if (this.buttonRef.current) {
				window.google.accounts.id.renderButton(this.buttonRef.current, {
					theme: "outline",
					size: "large",
					width: "100%",
				});
			}

			// Optionally show One Tap dialog
			// window.google.accounts.id.prompt();
		}
	};
	handleManualPrompt = () => {
		if (window.google && window.google.accounts) {
			window.google.accounts.id.prompt();
		}
	};
	handleGoogleSignIn = async () => {
		try {
			const res = await SocialLogin.login({
				provider: "google",
				options: isMobile ? { forcePrompt: true } : {},
			});
			this.setState({ isLoading: true });

			const credential = GoogleAuthProvider.credential((res.result as ExtendedGoogleLoginResponse).idToken);
			const result = await signInWithCredential(auth, credential);
			await this.linkPendingCredential(result.user);
			const bearerToken = await result.user.getIdToken();
			const userCreated = await createUser(
				bearerToken,
				result.user.uid,
				result.user.displayName?.trim(),
				result.user.metadata.creationTime,
				result.user.email
			);
			this.setState({ isLoading: false });
			if (!userCreated) {
				console.error("Failed to create user");
				return;
			}
			if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
			else this.props.history.replace("/");
		} catch (err) {
			this.setState({ isLoading: false });
			console.error("SIGN IN ERROR: ", err);
		}
	};
	handleMicrosoftSignIn = async () => {
		this.setState({ isLoading: true });
		try {
			const user = await signInWithMicrosoft();
			const bearerToken = await user.getIdToken();
			const userCreated = await createUser(
				bearerToken,
				user.uid,
				user.displayName?.trim(),
				user.metadata.creationTime,
				user.email ?? user.providerData[0]?.email
			);
			this.setState({ isLoading: false });
			if (!userCreated) {
				console.error("Failed to create user");
				return;
			}
			if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
			else this.props.history.replace("/");
		} catch (err) {
			this.setState({ isLoading: false });
			const code = getAuthErrorCode(err);
			if (code === "auth/account-exists-with-different-credential") {
				/* Linked after the user signs in with the provider already used for this email */
				const pendingCred = OAuthProvider.credentialFromError(err as AuthError);
				const email = (err as AuthError).customData?.email;
				const signInMethods = email ? await fetchSignInMethodsForEmail(auth, email).catch(() => [] as string[]) : [];
				if (email && signInMethods.includes("google.com")) {
					/* The Google popup needs a fresh click, so ask instead of opening it right away */
					this.setState({ pendingCred, linkWithGoogleEmail: email });
				} else {
					this.setState({
						pendingCred,
						showErrorMessageToast: true,
						errorMessage: this.fromErrorToLocalizedErrorMessage(code, this.state.language),
					});
				}
			} else if (code !== "auth/popup-closed-by-user" && code !== "auth/cancelled-popup-request") {
				console.error("[AuthGetStarted] microsoft sign-in error:", err);
			}
		}
	};
	linkPendingCredential = async (user: User) => {
		if (!this.state.pendingCred) return;
		await linkWithCredential(user, this.state.pendingCred)
			.then(() => console.log("[AuthGetStarted] microsoft account linked"))
			.catch((err) => console.error("[AuthGetStarted] error linking pending credential:", err));
		this.setState({ pendingCred: null });
	};
	fromErrorToLocalizedErrorMessage(error: string, language: string) {
		switch (error) {
			case "auth/account-exists-with-different-credential":
				switch (language) {
					case "it":
						return "È già stato effettuato l'accesso con un altro metodo di autenticazione. Scegliere un altro provider di autenticazione.";
					case "es":
						return "Ya ha iniciado sesión utilizando otro método de autenticación. Elija otro método de autenticación.";
					case "ca":
						return "Ja heu iniciat la sessió utilitzant un altre mètode d'autenticació. Trieu un altre proveïdor d'autenticació.";
					case "fr":
						return "Vous vous êtes déjà connecté en utilisant une autre méthode d'authentification. Choisissez un autre fournisseur d'authentification.";
					case "de":
						return "Sie haben sich bereits mit einer anderen Authentifizierungsmethode angemeldet. Wählen Sie einen anderen Authentifizierungsanbieter.";
					case "pt":
						return "Já iniciou sessão utilizando outro método de autenticação. Escolha outro fornecedor de autenticação.";

					default:
						return "You have already signed in by using another authentication method. Choose another authentication provider.";
				}

			default:
				return "";
		}
	}

	render() {
		const defaultOptions = {
			loop: true,
			autoplay: true,
			animationData: check,
			rendererSettings: {
				preserveAspectRatio: "xMidYMid slice",
			},
		};
		const { user, isSignedIn } = this.state;

		return (
			<IonPage className="authGetStartedPage">
				<div className="authGetStartedContainer">
					<IonHeader hidden /* ={!isMobile} */ className="ion-no-border authSupportHeader authGetStartedHeader"></IonHeader>
					<IonGrid className="authGetStartedMainGrid">
						{isIOS ? (
							<>
								<div className="authGetStartedTextDiv">
									<h2>
										<Trans>Get started</Trans>
									</h2>
								</div>
							</>
						) : this.state.fromReferral && this.state.referrerName ? (
							<>
								<div className="authGetStartedTextDiv">
									<h2>
										<Trans>{this.state.referrerName} ti ha invitato su</Trans>
									</h2>
								</div>
							</>
						) : (
							<>
								<div className="authGetStartedTextDiv">
									<h2>
										<Trans>Get started for Free</Trans>
									</h2>
								</div>
							</>
						)}

						<div className="authGetStartedIllustrationDiv">
							<IonImg src={reasyLogoBook} />
							<IonIcon className="authLoginLogoTxt" src={reasyScritta} />
						</div>

						<div className="authGetStartedButtonsDiv">
							{/* {isMobile && ( */}
							<IonButton color={"dark"} className="authGetStartedContinueWithButton" onClick={this.handleGoogleSignIn}>
								<IonIcon className="authGetStartedContinueWithButtonIcon" icon={logoGoogle} />
								<Trans>Continue with</Trans> Google
							</IonButton>
							{/* )} */}
							{/* <div
								ref={this.buttonRef}
								className="google-signin-wrapper"
								style={{
									padding: "0",
									marginBottom: "16px",
									minHeight: "40px",
									display: "flex",
									justifyContent: "center",
									borderRadius: "12px",
									overflow: "hidden",
									boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
									transition: "transform 0.2s ease",
								}}
							/> */}
							<IonButton color={"dark"} className="authGetStartedContinueWithButton" onClick={this.handleMicrosoftSignIn}>
								<IonIcon icon={logoMicrosoft} className="authGetStartedContinueWithButtonIcon" />
								<Trans>Continue with</Trans> Microsoft
							</IonButton>
							<IonButton
								hidden={isMobile}
								color={"dark"}
								className="authGetStartedContinueWithButton"
								onClick={() => {
									// signInWithPopup(auth, microsoftAuthProvider)
									// 	.then(async (result) => {
									// 		this.setState({ isLoading: true });
									// 		const credential = OAuthProvider.credentialFromResult(result);
									// 		const accessToken = credential!.accessToken;
									// 		const idToken = credential!.idToken;

									this.props.history.push(`/authentication/email-password-authentication`);

									if (true) {
										// signInWithCredential(auth, credential)
										// 	.then(async (res) => {
										// 		this.setState({ isLoading: false });
										// 		console.log("[AuthGetStarted] microsoft with linked credentials:", res);
										// 		if (res.user) {
										// 			const bearerToken = await res.user.getIdToken();
										// 			const userCreated = await createUser(
										// 				bearerToken,
										// 				res.user.uid,
										// 				res.user.displayName?.trim(),
										// 				res.user.metadata.creationTime,
										// 				res.user.email
										// 			);
										// 			console.log(userCreated);
										// 			if (!userCreated) {
										// 				console.error("Failed to create user");
										// 				return;
										// 			}
										// 			if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
										// 			else this.props.history.replace("/");
										// 		}
										// 	})
										// 	.catch(async (err) => {
										// 		this.setState({ isLoading: false });
										// 		console.error("[AuthGetStarded] microsoft - error linking credentials:", err);
										// 		if (err.user) {
										// 			const bearerToken = await err.user.getIdToken();
										// 			const userCreated = await createUser(
										// 				bearerToken,
										// 				err.user.uid,
										// 				err.user.displayName?.trim(),
										// 				err.user.metadata.creationTime,
										// 				err.user.email
										// 			);
										// 			console.log(userCreated);
										// 			if (!userCreated) {
										// 				console.error("Failed to create user");
										// 				return;
										// 			}
										// 			if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
										// 			else this.props.history.replace("/");
										// 		}
										// 	});
									} else {
										// if (result.user) {
										// 	const bearerToken = await result.user.getIdToken();
										// 	const userCreated = await createUser(
										// 		bearerToken,
										// 		result.user.uid,
										// 		result.user.displayName?.trim(),
										// 		result.user.metadata.creationTime,
										// 		result.user.email
										// 	);
										// 	console.log(userCreated);
										// 	if (!userCreated) {
										// 		console.error("Failed to create user");
										// 		return;
										// 	}
										// 	if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
										// 	else this.props.history.replace("/");
										// }
									}
									// })
									// .catch((err) => {
									// 	console.error("[AuthGetStarted] microsoft error signin-up:", err);
									// 	const credential = OAuthProvider.credentialFromError(err);
									// 	if (err.code === "auth/account-exists-with-different-credential") {
									// 		console.log("[AuthGetStarted] saving microsoft pending user");
									// 		this.setState({
									// 			pendingCred: credential,
									// 			showErrorMessageToast: true,
									// 			errorMessage: this.fromErrorToLocalizedErrorMessage(err.code, this.state.language),
									// 		});
									// 	}
									// });
								}}
							>
								<IonIcon className="authGetStartedContinueWithButtonIcon" />
								<Trans>Continua con email e password</Trans>
							</IonButton>
							<IonButton
								color={"dark"}
								hidden={!isIOS || (isAndroid && Capacitor.isNativePlatform())}
								className="authGetStartedContinueWithButton"
								onClick={async () => {
									if (isIOS) {
										let options: SignInWithAppleOptions = {
											clientId: "ai.tech4all.reasy",
											redirectURI: "localhost:8100/files/my-files",
											scopes: "email name",
											// state: '12345',
											// nonce: 'nonce',
										};
										SignInWithApple.authorize(options)
											.then((result: SignInWithAppleResponse) => {
												this.setState({ isLoading: true });
												// console.log("SIGNED IN with apple: ", result);
												// Handle user information
												// Validate token with server and create new session
												let credentials = appleAuthProvider.credential({ idToken: result.response.identityToken });
												signInWithCredential(auth, credentials)
													.then(async (response) => {
														this.setState({ isLoading: false });
														// console.log("SIGNED IN WITH CREDENTIAL: ", response);
														if (response.user) {
															await this.linkPendingCredential(response.user);
															const bearerToken = await response.user.getIdToken();
															const userCreated = await createUser(
																bearerToken,
																response.user.uid,
																response.user.displayName?.trim(),
																response.user.metadata.creationTime,
																response.user.email
															);
															console.log(userCreated);

															if (!userCreated) {
																console.error("Failed to create user");
																return;
															}
															if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
															else this.props.history.replace("/");
														}
													})
													.catch((err) => {
														this.setState({ isLoading: false });
														console.error("[AuthGetStarted] apple error signin-up:", err);
													});
											})
											.catch((error) => {
												console.log("ERROR SIGNING IN: ", error);
											});
									} else {
										const res = await SocialLogin.login({
											provider: "apple",
											options: {},
										});
										// signInWithPopup(auth, appleAuthProvider)
										// 	.then(async (result) => {
										// 		this.setState({ isLoading: true });
										// 		console.log("[AuthGetStarted] apple result:", result);
										// 		const credentials = OAuthProvider.credentialFromResult(result);
										// 		console.log("[AuthGetStarted] apple credentials:", credentials);
										console.log(res);
										// const credential = appleAuthProvider.credential(res.result.idToken);

										// 	if (this.state.pendingCred) {
										// 		signInWithCredential(auth, credential)
										// 			.then(async (res) => {
										// 				this.setState({ isLoading: false });
										// 				console.log("[AuthGetStarted] apple with linked credentials:", res);
										// 				if (result.user) {
										// 					const bearerToken = await result.user.getIdToken();
										// 					const userCreated = await createUser(
										// 						bearerToken,
										// 						result.user.uid,
										// 						result.user.displayName?.trim(),
										// 						result.user.metadata.creationTime,
										// 						result.user.email
										// 					);
										// 					console.log(userCreated);

										// 					if (!userCreated) {
										// 						console.error("Failed to create user");
										// 						return;
										// 					}
										// 					if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
										// 					else this.props.history.replace("/");
										// 				}
										// 			})
										// 			.catch(async (err) => {
										// 				this.setState({ isLoading: false });
										// 				console.error("[AuthGetStarded] apple - error linking credentials:", err);
										// 				if (result.user) {
										// 					const bearerToken = await result.user.getIdToken();
										// 					const userCreated = await createUser(
										// 						bearerToken,
										// 						result.user.uid,
										// 						result.user.displayName?.trim(),
										// 						result.user.metadata.creationTime,
										// 						result.user.email
										// 					);
										// 					console.log(userCreated);

										// 					if (!userCreated) {
										// 						console.error("Failed to create user");
										// 						return;
										// 					}
										// 					if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
										// 					else this.props.history.replace("/");
										// 				}
										// 			});
										// 	} else {
										// 		if (result.user) {
										// 			const bearerToken = await result.user.getIdToken();
										// 			const userCreated = await createUser(
										// 				bearerToken,
										// 				result.user.uid,
										// 				result.user.displayName?.trim(),
										// 				result.user.metadata.creationTime,
										// 				result.user.email
										// 			);
										// 			console.log(userCreated);

										// 			if (!userCreated) {
										// 				console.error("Failed to create user");
										// 				return;
										// 			}
										// 			if (this.state.fromInvitation) this.props.history.push({ pathname: "/invitation", state: { respondedToInvitation: true } });
										// 			else this.props.history.replace("/");
										// 		}
										// 	}
										// })
										// .catch((err) => {
										// 	console.error("[AuthGetStarted] apple error signin-up:", err);
										// 	const credential = OAuthProvider.credentialFromError(err);
										// 	if (err.code === "auth/account-exists-with-different-credential") {
										// 		console.log("[AuthGetStarted] saving apple pending user");
										// 		this.setState({
										// 			pendingCred: credential,
										// 			showErrorMessageToast: true,
										// 			errorMessage: this.fromErrorToLocalizedErrorMessage(err.code, this.state.language),
										// 		});
										// 	}
										// });
									}
								}}
							>
								<IonIcon icon={logoApple} className="authGetStartedContinueWithButtonIcon" />
								<Trans>Continue with</Trans> Apple
							</IonButton>
						</div>

						<div className="getStartedLegalTermsDiv">
							<p>
								<Trans>By registering you confirm that you have read and understood our</Trans>&nbsp;
								<a href="https://app.reasyedu.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
									<Trans>privacy policy</Trans> {/* TO LOCALIZE THIS */}
								</a>
								, <Trans>the</Trans>&nbsp;
								<a href="https://app.reasyedu.com/legal/cookie-policy" target="_blank" rel="noopener noreferrer">
									<Trans>cookie policy</Trans> {/* TO LOCALIZE THIS */}
								</a>
								<Trans> e i </Trans>
								<a href="https://app.reasyedu.com/legal/terms-conditions" target="_blank" rel="noopener noreferrer">
									<Trans>terms and conditions</Trans>
								</a>
								.
							</p>
						</div>

						<div /* hidden={isMobile}  */ className="languageContainer-Auth cardBg">
							<div className="settingsDocumentViewingItemDiv" style={{ display: "flex", flexDirection: "row", justifyContent: "center", width: "100%" }}>
								<IonIcon className="lnIcon" slot="start" icon={globeOutline} />
								<IonSelect
									style={{ width: "fit-content", paddingLeft: "25px" }}
									className="appLanguageSelect"
									id="setLanguage"
									value={this.state.language}
									toggleIcon={chevronDownOutline}
									//value={this.state.language == "" ? i18n.language : this.state.language}
									interface={isMobile ? "action-sheet" : "popover"}
									onIonChange={(e) => {
										if (e.detail.value != i18n.language) {
											i18n.changeLanguage(e.detail.value);
											this.setState({ languageChanged: true, language: e.detail.value }, () => {});
										}
									}}
								>
									<IonSelectOption value="it">Italiano</IonSelectOption>
									<IonSelectOption value="en">English</IonSelectOption>
									<IonSelectOption value="fr">Français</IonSelectOption>
									<IonSelectOption value="es">Español</IonSelectOption>
									<IonSelectOption value="de">Deutsch</IonSelectOption>
									<IonSelectOption value="ca">Català</IonSelectOption>
								</IonSelect>
							</div>
						</div>
					</IonGrid>

					<IonAlert
						isOpen={!!this.state.linkWithGoogleEmail}
						header={i18n.t("Account already exists")}
						message={i18n.t("An account with {{email}} already exists. Sign in with {{provider}}: Microsoft will be linked to your account and next time you can use either one.", {
							email: this.state.linkWithGoogleEmail,
							provider: "Google",
						})}
						buttons={[
							{ text: i18n.t("Cancel"), role: "cancel" },
							{ text: `${i18n.t("Continue with")} Google`, handler: () => void this.handleGoogleSignIn() },
						]}
						onDidDismiss={() => this.setState({ linkWithGoogleEmail: null })}
					/>
					<IonToast
						onDidDismiss={() => this.setState({ showErrorMessageToast: false, errorMessage: "" })}
						isOpen={this.state.showErrorMessageToast}
						message={this.state.errorMessage ? this.state.errorMessage : ""}
						duration={3000}
					/>
					<IonLoading
						isOpen={this.state.isLoading}
						message={
							i18n.language === "it"
								? "Caricamento..."
								: i18n.language === "en"
								? "Loading..."
								: i18n.language === "fr"
								? "Chargement..."
								: i18n.language === "es"
								? "Cargando..."
								: i18n.language === "de"
								? "Laden..."
								: i18n.language === "ca"
								? "Carregant..."
								: i18n.language === "pt"
								? "Carregando..."
								: i18n.language === "cz"
								? "Carregando..."
								: i18n.language === "nl"
								? "Bezig met laden..."
								: ""
						}
					/>
					{this.props.isAuthenticated && <Redirect to="/" />}
				</div>
			</IonPage>
		);
	}
}

const mapStateToProps = (state: any) => {
	return {
		isAuthenticated: state.auth.access ? true : false,
	};
};

const mapDispatchToProps = (dispatch: any) => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationGetStarted);
